/**
 * Represents an error of a non-error object
 * that looked enough like an error to recreate
 * it using this Error subclass
 */
export class ErrorLikeError extends Error {
  public readonly org: object;
  constructor(obj: {
    name: string;
    message: string;
    stack?: string;
    org: object;
  }) {
    super(obj.message);
    this.name = obj.name;
    this.org = obj.org;
    if (obj.stack) {
      this.stack = obj.stack;
    }
  }
}
